/****************************************************
 * Module Name:  floProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class FloProxy {
  static GetAllFlo = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/flo",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllFloMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/flo/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleFlo = (floId, callback) => {
    let params = {
      id: floId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/flo",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckFloAvailable = (flo, callback) => {
    let params = {
      flo: flo,
    };

    restAPICall(
      Constants.MANAGER_URL + "/flo/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddFlo = (flo, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/flo",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(flo),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateFlo = (flo, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/flo",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(flo),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
